import { render } from "./MatchListDropdown.vue?vue&type=template&id=b7bd444e&scoped=true"
import script from "./MatchListDropdown.vue?vue&type=script&lang=js"
export * from "./MatchListDropdown.vue?vue&type=script&lang=js"

import "./MatchListDropdown.vue?vue&type=style&index=0&id=b7bd444e&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/production-allsports-2/production-as-fe-fj-SSR/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b7bd444e"]])

export default __exports__